import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../service";
import {IErrorResponse, IRootState} from "../../../../types";
import {
    deletedEducationalBlocks, deletedRestoreEducationalBlocks,
    setEducationalBlockData, setEducationalBlocksRestoreData,
    setEducationalBlockTypes, updateEducationalBlocks,
    updateEducationalSettings
} from "./educationalBlocksSlice";

import {IEducationalBlocksCreate, IEducationalBlocksPayload, IEducationalBlockTypesPayload} from "../types";

const SetEducationalBlocks = createAsyncThunk(
    "create/educational/blocks",
    async ( data : IEducationalBlocksCreate,{rejectWithValue}) => {
        try {
            const response = await request.post("/educational-blocks", data);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const GetEducationalBlocks = createAsyncThunk(
    "get/educational/blocks",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.get("educational-blocks");


            dispatch(setEducationalBlockData({data:response.data}))
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);
const GetEducationalBlockTypes = createAsyncThunk(
    "get/educational/blocks/types",
    async (_, { dispatch, rejectWithValue,getState }) => {
        try {
            const response = await request.get("educational-block-types");

            const lang = getState()  as IRootState
            const defaultLanguage = lang.languages.defaultLanguage
            dispatch(setEducationalBlockTypes({data:response.data,defaultLanguage}))
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const EditEducationalBlocks = createAsyncThunk(
    "edit/educational/blocks",
    async (data: IEducationalBlocksPayload, {dispatch, rejectWithValue}) => {

        try {
            const response = await request.put(`/educational-blocks/${data.id}`, data);
            dispatch(updateEducationalBlocks(data))
            return response.data;
        }  catch (error) {

            const typedError = error as IErrorResponse;

            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const EditEducationalSettings = createAsyncThunk(
    "edit/educational/settings",
    async (data: IEducationalBlockTypesPayload, {dispatch, rejectWithValue}) => {

        try {
            const response = await request.put(`/educational-block-types/${data.id}`, data);
            dispatch(updateEducationalSettings(data))
            return response.data;
        }  catch (error) {

            const typedError = error as IErrorResponse;

            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const DeleteEducationalBlocks = createAsyncThunk(
    "delete/educational/blocks",
    async (id: number, {rejectWithValue,dispatch}) => {
        try {
            const response = await request.delete(`/educational-blocks/${id}`);


            dispatch(deletedEducationalBlocks(id))

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const GetDeleteEducationalBlocks = createAsyncThunk(
    "get/delete/educational/blocks",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/educational-blocks/deleted-items`);


            dispatch(setEducationalBlocksRestoreData(response.data))
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);



const RestoreDeleteEducationalBlocks = createAsyncThunk(
    "restore/educational/blocks",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/educational-blocks/restore/${id}`);

            dispatch(deletedRestoreEducationalBlocks(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


export{
    GetEducationalBlocks,
    GetEducationalBlockTypes,
    SetEducationalBlocks,
    EditEducationalBlocks,
    DeleteEducationalBlocks,
    EditEducationalSettings,
    GetDeleteEducationalBlocks,
    RestoreDeleteEducationalBlocks
}